var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1495_6233",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.34671 1.18568L15.061 2.61425C15.6967 2.77282 16.1431 3.34425 16.1431 3.99996V4.96282C16.1431 9.53782 13.6717 13.7528 9.69385 15.9628C9.47814 16.0828 9.23956 16.1428 9.00028 16.1428C8.76099 16.1428 8.52242 16.0828 8.30671 15.9628C4.32885 13.7528 1.85742 9.53782 1.85742 4.96282V3.99996C1.85742 3.34425 2.30385 2.77282 2.93956 2.61425L8.65385 1.18568C8.76742 1.15711 8.88385 1.14282 9.00028 1.14282C9.11671 1.14282 9.23314 1.15711 9.34671 1.18568ZM9.00028 14.7143C12.5274 12.755 14.7146 8.99711 14.7146 4.96282V3.99997L9.00028 2.57139V14.7143Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1495_6233)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.428711,
    y: 0.428467,
    width: 17.1429,
    height: 17.1429,
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.d25a6b4fa6750ac19021af5c1a8d674e.svg";
export { ForwardRef as ReactComponent };